import { styled, Box, Typography } from '../../../base'; // Assuming base exports these

export const Wrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    textAlign: 'center', // Center text by default for top parts
});

export const TopContentWrapper = styled(Box)({
    flexGrow: 1, // Pushes the QuestionTextWrapper down
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px', // Some padding around the centered text
});

export const HeadingText = styled(Typography)<{
    component?: React.ElementType;
}>(({ theme }) => ({
    color: theme.palette.primary.main, // Example: Primary color for heading
    marginBottom: theme.spacing(1),
}));

export const SubheadingText = styled(Typography)<{
    component?: React.ElementType;
}>(({ theme }) => ({
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(4), // Space before the question area might visually appear
}));

export const QuestionTextWrapper = styled(Box)(({ theme }) => ({
    width: '100%', // Take full width to allow left alignment of text
    textAlign: 'start',
    // This wrapper itself is pushed down by TopContentWrapper's flexGrow
}));

export const QuestionText = styled(Typography)<{
    component?: React.ElementType;
}>(({ theme }) => ({
    color: theme.palette.text.primary,
}));
